import { useState, useEffect, ReactElement } from 'react';
import Slider from 'react-rangeslider';
import 'react-rangeslider/lib/index.css';
import { DynamicTypography } from '@components/DynamicTypography';
import { FormValue, Question } from '@app/types';

interface GroupProps {
  key: string;
  options: Question[];
}

interface Type3Props {
  group: GroupProps;
  g: { options: Question[] };
  values: Record<string, FormValue>;
  setFieldValue: (key: string, value: number) => void;
}

export const Type3 = ({ group, g, values, setFieldValue }: Type3Props): ReactElement => {
  const [value, setValue] = useState(values[group.key] || 0);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 800);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 800);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const renderTicks = () => (
    <div className="slider-ticks">
      {Array.from({ length: 11 }).map((_, k) => (
        <span
          key={`tick_${k}`}
          className="slider-tick"
          style={{
            [isMobile ? 'right' : 'top']:
              k === 0 ? (isMobile ? '97%' : '97%') : `${(10 - k) * 9.6}%`
          }}
        >
          {k * 10}
        </span>
      ))}
    </div>
  );

  return (
    <div className="type-3-questionnaire">
      <div className="content">
        <DynamicTypography content={g.options[0].description} />
      </div>
      <div className="content-slider">
        <div className="slider-component">
          {renderTicks()}
          <Slider
            min={0}
            max={100}
            orientation={isMobile ? 'horizontal' : 'vertical'}
            tooltip={false}
            value={value as number}
            onChange={setValue}
            onChangeComplete={() => setFieldValue(group.key, value as number)}
          />
          <div className="slider-tick-helpers">
            {g.options[0].graph_top && (
              <DynamicTypography component="span" content={g.options[0].graph_top} />
            )}
            {g.options[0].graph_bottom && (
              <DynamicTypography component="span" content={g.options[0].graph_bottom} />
            )}
          </div>
        </div>
        <div className="slider-value">
          <div>
            <strong>{value}</strong>
            <DynamicTypography component="span" content={g.options[0].graph_value} />
          </div>
        </div>
      </div>
    </div>
  );
};
